var hashtag_default = {
  "fontElementMap": "Twej9",
  "hashtag": "bEnJg"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
